import { Outlet } from 'react-router-dom'

const ModalPageLayout = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default ModalPageLayout
